var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as CollaboratorService from "../service/collaborator-service.js";
import { Resource } from "./Resource.js";
/**
 * This class defines a Collaborator of a [[Book]].
 *
 * A Collaborator represents a user that has been granted access to a Book with specific permissions.
 *
 * @public
 */
export class Collaborator extends Resource {
    constructor(book, payload) {
        super(payload);
        this.book = book;
    }
    /** @internal */
    getConfig() {
        return this.book.getConfig();
    }
    /**
     * Gets the Collaborator internal id.
     *
     * @returns The Collaborator internal id
     */
    getId() {
        return this.payload.id;
    }
    /**
     * Gets the Collaborator email address.
     *
     * @returns The Collaborator email address
     */
    getEmail() {
        return this.payload.email;
    }
    /**
     * Sets the email address of the Collaborator.
     *
     * @param email - The email address to set
     *
     * @returns This Collaborator, for chaining
     */
    setEmail(email) {
        this.payload.email = email;
        return this;
    }
    /**
     * Gets the permission level of the Collaborator.
     *
     * @returns The permission level
     */
    getPermission() {
        return this.payload.permission;
    }
    /**
     * Sets the permission level of the Collaborator.
     *
     * @param permission - The permission level to set
     *
     * @returns This Collaborator, for chaining
     */
    setPermission(permission) {
        this.payload.permission = permission;
        return this;
    }
    /**
     * Gets the public avatar url of the Collaborator.
     *
     * @returns The Collaborator's public avatar url
     */
    getAvatarUrl() {
        return this.payload.avatarUrl;
    }
    /**
     * Performs create new Collaborator.
     *
     * @returns Promise with the created Collaborator
     */
    create(message) {
        return __awaiter(this, void 0, void 0, function* () {
            this.payload = yield CollaboratorService.addOrUpdateCollaborator(this.book.getId(), this.payload, message, this.getConfig());
            this.book.clearCollaboratorCache();
            return this;
        });
    }
    /**
     * Performs update Collaborator.
     *
     * @returns Promise with the updated Collaborator
     */
    update() {
        return __awaiter(this, void 0, void 0, function* () {
            this.payload = yield CollaboratorService.addOrUpdateCollaborator(this.book.getId(), this.payload, undefined, this.getConfig());
            this.book.clearCollaboratorCache();
            return this;
        });
    }
    /**
     * Performs remove Collaborator.
     *
     * @returns Promise with the removed Collaborator
     */
    remove() {
        return __awaiter(this, void 0, void 0, function* () {
            const email = this.getEmail();
            if (!email) {
                throw new Error("Collaborator email is required");
            }
            this.payload = yield CollaboratorService.removeCollaborator(this.book.getId(), email, this.getConfig());
            this.book.clearCollaboratorCache();
            return this;
        });
    }
}
//# sourceMappingURL=Collaborator.js.map